// TODO move to a more appropriate location

function getFontFormat(font: string): string {
  const fontFormat = font.split('.').pop()?.toLowerCase();
  switch (fontFormat) {
    case 'woff':
      return 'woff';
    case 'woff2':
      return 'woff2';
    case 'ttf':
      return 'truetype';
    case 'otf':
      return 'opentype';
    case 'eot':
      return 'embedded-opentype';
    default:
      return '';
  }
}

export function generateFontFace(args: {
  fontFamily: string;
  fontUrl: string;
  fontWeight?: string;
  fontStyle?: string;
}): string {
  const { fontFamily, fontUrl, fontWeight = '500', fontStyle = 'normal' } = args;
  return `
      @font-face {
        font-family: '${fontFamily}';
        src: url('${fontUrl}') format('${getFontFormat(fontUrl)}');
        font-weight: ${fontWeight};
        font-style: ${fontStyle};
      }
    `;
}
